module.exports = __webpack_public_path__ + "img/top-right.cb9da8ed.jpg";